/*
  Strings added with the campaign page tabs and the dashboard refresh.
  Merged into TRANSLATION_MAPS in ./index.js.
*/

const ru = {
  'Fallback rules': 'Запасные правила',
  'Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.': 'Срабатывают, только если клик не подошёл ни под один поток кампании. Основную маршрутизацию настраивайте в потоках, а здесь — редкие запасные случаи.',
  'Add the banner to your landing page': 'Добавьте баннер на лендинг',
  'Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.': 'Вставьте эту строку в <head> каждого лендинга кампании. Баннер показывается, только пока он включён выше, и только посетителям из выбранных регионов.',
  'Copy code': 'Скопировать код',
  'No campaigns yet': 'Кампаний пока нет',
  Audience: 'Аудитория',
  'Updated at {time}': 'Обновлено в {time}',
  'Download ZIP': 'Скачать ZIP',
  'Download failed': 'Не удалось скачать',
};

const es = {
  'Fallback rules': 'Reglas de respaldo',
  'Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.': 'Solo se usan cuando un clic no coincide con ningún flujo de la campaña. Configura el enrutamiento en los flujos y deja aquí los casos poco frecuentes.',
  'Add the banner to your landing page': 'Añade el banner a tu landing',
  'Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.': 'Pega esta línea en el <head> de cada landing de la campaña. El banner se muestra solo mientras esté activado arriba y solo a visitantes de las regiones elegidas.',
  'Copy code': 'Copiar código',
  'No campaigns yet': 'Aún no hay campañas',
  Audience: 'Audiencia',
  'Updated at {time}': 'Actualizado a las {time}',
  'Download ZIP': 'Descargar ZIP',
  'Download failed': 'No se pudo descargar',
};

const pt = {
  'Fallback rules': 'Regras de reserva',
  'Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.': 'Usadas só quando um clique não corresponde a nenhum fluxo da campanha. Configure o roteamento nos fluxos e deixe aqui os casos raros.',
  'Add the banner to your landing page': 'Adicione o banner à sua landing',
  'Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.': 'Cole esta linha no <head> de cada landing da campanha. O banner aparece só enquanto estiver ativado acima e só para visitantes das regiões escolhidas.',
  'Copy code': 'Copiar código',
  'No campaigns yet': 'Ainda não há campanhas',
  Audience: 'Público',
  'Updated at {time}': 'Atualizado às {time}',
  'Download ZIP': 'Baixar ZIP',
  'Download failed': 'Não foi possível baixar',
};

const UX_EXTRA = { ru, es, pt };
export default UX_EXTRA;
